// hooks/useDiligence.js
import { useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { diligenceTypeObservable } from '../observers/Observable';

export const useDiligence = (oid) => {
  const ownerId = useRef(oid);
  const currentStatus = useRef(diligenceTypeObservable.getValue());

  useEffect(() => {
    const unsubscribe = diligenceTypeObservable.subscribe((newStatus) => {
      currentStatus.current = newStatus;
    });

    // rever only when required.
  }, []);

  const setDiligenceStatus = (status, isEnhanced = false) => {
    return diligenceTypeObservable.setValue(status, {
      by: ownerId.current,
      isEnhanced
    });
  };

  return {
    currentStatus: currentStatus.current,
    setDiligenceStatus,
    ownerId: ownerId.current
  };
};